import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';
// Import your logo from assets
import logo from '../assets/logo.png'; // Adjust the path and filename as needed

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleBookNow = () => {
    // Close the menu first
    setIsOpen(false);
    // Initiate phone call
    window.location.href = 'tel:+918019472678';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>
            <img 
              src={logo} 
              alt="AA GRAND HOTEL" 
              className="navbar-logo-img"
            />
          </Link>
        </div>

        {/* Hamburger Menu Icon */}
        <div className={`menu-icon ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* Nav Menu */}
        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/rooms" className="nav-link" onClick={closeMenu}>
              Rooms
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/gallery" className="nav-link" onClick={closeMenu}>
              Gallery
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={closeMenu}>
              About
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={closeMenu}>
              Contact
            </Link>
          </li>
          <li className="nav-item">
            <button 
              className="nav-link book-btn" 
              onClick={handleBookNow}
            >
              📞 Book Now
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;